import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { WhatsComingPage } from "~/components/feature-votes/whats-coming-page";
import { myFeatureVotesQueryOptions } from "~/lib/functions/feature-votes";
import { visibleFeaturesQueryOptions } from "~/lib/functions/features";

export const Route = createFileRoute("/_user/my-coaching/whats-coming")({
  staticData: { title: "What's coming" },
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(myFeatureVotesQueryOptions),
      context.queryClient.ensureQueryData(visibleFeaturesQueryOptions),
    ]);
    return {};
  },
  component: WhatsComingRoute,
});

function WhatsComingRoute(): React.JSX.Element {
  const { data } = useQuery(visibleFeaturesQueryOptions);
  return <WhatsComingPage features={data ?? []} />;
}
